
import { eTrangThaiHocActionsObj } from "../../action-types/category/ITrangThaiHocActions";
import { generateActions } from "../generateActions";


export const trangThaiHocActions = {
    ...generateActions(eTrangThaiHocActionsObj, "TRANG_THAI_HOC"),
}